import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../config/firebase';

export const uploadImage = async (file: File, path: string): Promise<string> => {
  try {
    const storageRef = ref(storage, path);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Erro ao fazer upload da imagem:', error);
    throw error;
  }
};

export const deleteImage = async (url: string): Promise<void> => {
  try {
    const storageRef = ref(storage, url);
    await deleteObject(storageRef);
  } catch (error) {
    console.error('Erro ao deletar imagem:', error);
    throw error;
  }
};

export const generateFilePath = (folder: string, fileName: string): string => {
    const extension = fileName.split('.').pop();
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
    return `${folder}/${uniqueId}.${extension}`;
};
